"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const fuzzysearch_1 = __importDefault(require("fuzzysearch"));
const objectToMap_1 = __importDefault(require("./objectToMap"));
function search(needle, haystack, options) {
    const deburredNeedle = lodash_1.deburr(needle);
    const deburredHaystack = lodash_1.deburr(haystack);
    if (options.caseInsensitive) {
        return fuzzysearch_1.default(lodash_1.toLower(deburredNeedle), lodash_1.toLower(deburredHaystack));
    }
    return fuzzysearch_1.default(deburredNeedle, deburredHaystack);
}
function deepSearchMap(query, map, options = {}) {
    if (!query) {
        return map;
    }
    const result = new Map();
    map.forEach((value, key) => {
        const hasKeyMatch = search(query, key, options);
        if (lodash_1.isObject(value)) {
            const valueResult = deepSearchMap(query, objectToMap_1.default(value), options);
            if (hasKeyMatch || valueResult.size) {
                result.set(key, valueResult);
            }
        }
        else {
            const hasValueMatch = search(query, String(value), options);
            if (hasKeyMatch || hasValueMatch) {
                result.set(key, value);
            }
        }
    });
    return result;
}
exports.default = deepSearchMap;
